import BlNavBarSearchMv from './BlNavBarSearchMv.vue'

BlNavBarSearchMv.install = function(Vue) {
  Vue.component(BlNavBarSearchMv.name, BlNavBarSearchMv)
}

export default BlNavBarSearchMv
